var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFacebookBlack = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 21,
  height: 21
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M6 7.014h2.002V4.827c0-.913.1-2.348.8-3.26C9.505.65 10.46 0 12.053 0c2.675 0 3.758.39 3.758.39l-.511 3.2s-.89-.26-1.72-.26c-.828 0-1.628.325-1.628 1.108V6.95h3.476l-.255 3.03h-3.22v10.994h-3.95V9.946H6V6.914"
})));
export default SvgFacebookBlack;